// Question Restriction options for product dialogs
export const questionRestrictionOptions = [
  { value: "-1", label: "All Restrictions" },
  { value: "0", label: "Assessment" },
  { value: "1", label: "Practice" },
  { value: "2", label: "Testbank" },
  { value: "3", label: "Adaptive" }
];

export const getQuestionRestrictionLabel = (value?: string) => {
  if (!value) return '';
  return questionRestrictionOptions.find(option => option.value === value)?.label;
};